import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {UtilsService} from "./utils.service";
import {
  COMPLETED, ERROR, WAITING
} from "../../app/private/database/database-group-info/dialogs/code-importation-dialog/code-importation-dialog.component";
import {FormTemplate} from "@icure/api";
import {GROUP_ID_TEMPLATE} from "./tools.service";

@Injectable({
  providedIn: 'root',
})
export class FormTemplateService {
  constructor(
    private api: ApiService,
    private utils: UtilsService
  ) {
  }

  public async getFormTemplatesBySpecialtyInGroup(groupId: string, specialityCodes: string[]): Promise<FormTemplate[]> {
    let formTemplates: FormTemplate[] = [];

    for (const specialityCode of specialityCodes) {
      const ft: FormTemplate[] =
        await this.api.formApi.getFormTemplatesBySpecialtyInGroup(groupId, specialityCode, false);

      formTemplates = [...formTemplates, ...ft];
    }

    return formTemplates;
  }

  public async injectFormTemplateIntoDb(
    targetGroupId: string,
    sourceTemplateId: string
  ): Promise<{
    injectedFormTemplate: number;
    updatedFormTemplate: number;
    status: string;
  }> {
    try {
      const sourceFormTemplate = await this.api.formApi.getFormTemplateInGroup(GROUP_ID_TEMPLATE, sourceTemplateId!!, true);
      const existingTemplates: FormTemplate[] = await this.api.formApi.getFormTemplatesInGroup(targetGroupId, [sourceTemplateId!!], false);
      const existingTemplate = existingTemplates[0];
      const {id: _sid, rev: _srev, ...sourceWithoutIdRev} = sourceFormTemplate as any;
      if (!existingTemplate?.id) {
        const templateToInject = {
          ...sourceFormTemplate,
          rev: undefined as string | undefined,
          layoutAttachmentId: undefined as string | undefined,
          // @ts-ignore
          type: sourceFormTemplate.type ?? 'org.taktik.icure.entities.FormTemplate'
        }
        const createdFormTemplate: FormTemplate = await this.api.formApi.createFormTemplateInGroup(targetGroupId, templateToInject);
        const injectedAttachment: string = await this.api.formApi.setTemplateAttachmentInGroup(targetGroupId, sourceFormTemplate.id!!, sourceFormTemplate?.rawTemplateLayout!!);
        return {injectedFormTemplate: 1, updatedFormTemplate: 0, status: COMPLETED};
      } else {

        const templateToUpdate: FormTemplate = {
          ...(existingTemplate as FormTemplate),
          ...(sourceWithoutIdRev as Partial<FormTemplate>),
          id: existingTemplate.id,
          rev: existingTemplate.rev,
          templateLayoutAttachmentId: existingTemplate.templateLayoutAttachmentId,
          // @ts-ignore
          type: (sourceFormTemplate as any).type ?? (existingTemplate as any).type ?? 'org.taktik.icure.entities.FormTemplate',
        };

        const updatedFormTemplate: FormTemplate = await this.api.formApi.updateFormTemplateInGroup(targetGroupId, sourceFormTemplate?.id!!, templateToUpdate);
        const updatedAttachment: string = await this.api.formApi.setTemplateAttachmentInGroup(targetGroupId, sourceFormTemplate.id!!, sourceFormTemplate?.rawTemplateLayout!!);
        return {injectedFormTemplate: 0, updatedFormTemplate: 1, status: COMPLETED};
      }
    } catch (e) {
      console.error('Failed to inject form template:', e);
      return {injectedFormTemplate: 0, updatedFormTemplate: 0, status: ERROR};
    }
  }

}
